var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 40,
    viewBox: "0 0 101 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5022 22.4033V17.8855H35.6524V22.4033H32.6145V36.7489H35.8074V22.7802H65.1924V36.4848H68.3853V22.4033H65.5022Z",
    fill: "#B5ED30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6105 14.5962H55.389V11.4033H45.8422V3.19293H55.389V0H45.6105V2.94703H42.6492V11.6669H45.6105V14.5962Z",
    fill: "#B5ED30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4209 2.94678H58.6138V11.6685H55.4209V2.94678Z",
    fill: "#B5ED30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.117 25.5595V21.0417H68.2672V25.5595H65.2292V39.9052H68.4222V25.9364H97.8072V39.641H101V25.5595H98.117Z",
    fill: "#B5ED30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.225 17.7525H88.0035V14.5596H78.4567V6.34918H88.0035V3.15625H78.225V6.10328H75.2637V14.8232H78.225V17.7525Z",
    fill: "#B5ED30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0354 6.10303H91.2283V14.8247H88.0354V6.10303Z",
    fill: "#B5ED30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8877 25.5595V21.0417H3.03794V25.5595H0V39.9052H3.19293V25.9364H32.5779V39.641H35.7708V25.5595H32.8877Z",
    fill: "#B5ED30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.996 17.7525H22.7745V14.5596H13.2277V6.34918H22.7745V3.15625H12.996V6.10328H10.0347V14.8232H12.996V17.7525Z",
    fill: "#B5ED30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8062 6.10303H25.9991V14.8247H22.8062V6.10303Z",
    fill: "#B5ED30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.ba4f6d3f9e0f16c97d7e4bf73f8b51ad.svg";
export { ForwardRef as ReactComponent };